
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7903"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7903"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gv1ku", function(module, exports) {

$parcel$export(module.exports, "hasDraftContent", () => $c030929f534f7bed$export$94a615a503370f61);
$parcel$export(module.exports, "initPostComposerForm", () => $c030929f534f7bed$export$4470b0aff7e42ff);
$parcel$export(module.exports, "syncQueuedPostsIfOnline", () => $c030929f534f7bed$export$d3c5d8964ec31a13);
$parcel$export(module.exports, "retryQueuedPostsOnReconnect", () => $c030929f534f7bed$export$48211b535e2492e0);
// Shared post-composer logic — powers both the standalone /app page (app.js)
// and the feed's inline "+ New Post" modal (post-composer-modal.js), so the
// two entry points can never drift out of sync. Assumes the #post-form
// markup (and its child field IDs) is present in the document wherever
// initPostComposerForm() is called.

var $egRyG = parcelRequire("egRyG");

var $5IRmI = parcelRequire("5IRmI");

var $36CJS = parcelRequire("36CJS");
// ─── IndexedDB offline queue ──────────────────────────────────────────────────
class $c030929f534f7bed$var$PostQueue {
    constructor(){
        this._db = null;
    }
    async init() {
        if (this._db) return;
        this._db = await new Promise((resolve, reject)=>{
            const req = indexedDB.open('SlingsArrows', 1);
            req.onerror = ()=>reject(req.error);
            req.onsuccess = ()=>resolve(req.result);
            req.onupgradeneeded = (e)=>{
                const db = e.target.result;
                if (!db.objectStoreNames.contains('pending-posts')) db.createObjectStore('pending-posts', {
                    keyPath: 'id'
                });
            };
        });
    }
    _tx(mode) {
        return this._db.transaction([
            'pending-posts'
        ], mode).objectStore('pending-posts');
    }
    add(postData, token) {
        const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        const record = {
            id: id,
            data: postData,
            token: token,
            createdAt: new Date().toISOString()
        };
        return new Promise((resolve, reject)=>{
            const req = this._tx('readwrite').add(record);
            req.onerror = ()=>reject(req.error);
            req.onsuccess = ()=>resolve(record);
        });
    }
    remove(id) {
        return new Promise((resolve, reject)=>{
            const req = this._tx('readwrite').delete(id);
            req.onerror = ()=>reject(req.error);
            req.onsuccess = ()=>resolve();
        });
    }
    getAll() {
        return new Promise((resolve, reject)=>{
            const req = this._tx('readonly').getAll();
            req.onerror = ()=>reject(req.error);
            req.onsuccess = ()=>resolve(req.result || []);
        });
    }
}
const $c030929f534f7bed$var$postQueue = new $c030929f534f7bed$var$PostQueue();
let $c030929f534f7bed$var$queueReady = null;
function $c030929f534f7bed$var$ensureQueueReady() {
    if (!$c030929f534f7bed$var$queueReady) $c030929f534f7bed$var$queueReady = $c030929f534f7bed$var$postQueue.init();
    return $c030929f534f7bed$var$queueReady;
}
// ─── Media helpers ────────────────────────────────────────────────────────────
/**
 * Compress an image File to WebP at ≤1920×1080, quality 0.82.
 * Returns a Blob.
 */ async function $c030929f534f7bed$var$compressImage(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onerror = reject;
        reader.onload = (ev)=>{
            const img = new Image();
            img.onerror = reject;
            img.onload = ()=>{
                const MAX_W = 1920;
                const MAX_H = 1080;
                let { width: width, height: height } = img;
                if (width > MAX_W) {
                    height = Math.round(height * MAX_W / width);
                    width = MAX_W;
                }
                if (height > MAX_H) {
                    width = Math.round(width * MAX_H / height);
                    height = MAX_H;
                }
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                canvas.getContext('2d').drawImage(img, 0, 0, width, height);
                canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error('Canvas toBlob failed')), 'image/webp', 0.82);
            };
            img.src = ev.target.result;
        };
        reader.readAsDataURL(file);
    });
}
/**
 * Return the duration (seconds) of a video File without loading the full file.
 */ function $c030929f534f7bed$var$getVideoDuration(file) {
    return new Promise((resolve, reject)=>{
        const video = document.createElement('video');
        video.preload = 'metadata';
        const src = URL.createObjectURL(file);
        video.onloadedmetadata = ()=>{
            URL.revokeObjectURL(src);
            resolve(video.duration);
        };
        video.onerror = ()=>{
            URL.revokeObjectURL(src);
            reject(new Error('Could not read video'));
        };
        video.src = src;
    });
}
// ─── Read More break ────────────────────────────────────────────────────────
// Inserts the same marker post-render.js's renderPost() looks for to split a
// post into a feed excerpt + full permalink page. Must stay in sync with
// READ_MORE_MARKER in src/js/post-render.js.
const $c030929f534f7bed$var$READ_MORE_MARKER = '<!--more-->';
function $c030929f534f7bed$var$initReadMoreButton(bodyInput) {
    const btn = document.getElementById('insert-readmore-btn');
    if (!btn) return;
    btn.addEventListener('click', ()=>{
        if (bodyInput.value.includes($c030929f534f7bed$var$READ_MORE_MARKER)) {
            alert('This post already has a Read More break.');
            return;
        }
        const start = bodyInput.selectionStart ?? bodyInput.value.length;
        const end = bodyInput.selectionEnd ?? bodyInput.value.length;
        const value = bodyInput.value;
        const insertion = `\n\n${$c030929f534f7bed$var$READ_MORE_MARKER}\n\n`;
        bodyInput.value = value.slice(0, start) + insertion + value.slice(end);
        bodyInput.focus();
        const caret = start + insertion.length;
        bodyInput.setSelectionRange(caret, caret);
    });
}
// ─── Insert-link toolbar ────────────────────────────────────────────────────
// Lets the signed-in author insert a safe `[text](https://…)` link into the
// body textarea. Rendered as a real <a> on the feed by post-render.js, which
// parses only this exact syntax — no raw HTML is ever stored.
function $c030929f534f7bed$var$initLinkInsertPanel(bodyInput) {
    const toggleBtn = document.getElementById('insert-link-btn');
    const panel = document.getElementById('link-insert-panel');
    const textInput = document.getElementById('link-text-input');
    const urlInput = document.getElementById('link-url-input');
    const confirmBtn = document.getElementById('link-insert-confirm');
    const cancelBtn = document.getElementById('link-insert-cancel');
    const status = document.getElementById('link-insert-status');
    if (!toggleBtn || !panel) return;
    let savedSelection = {
        start: 0,
        end: 0
    };
    toggleBtn.addEventListener('click', ()=>{
        savedSelection = {
            start: bodyInput.selectionStart ?? bodyInput.value.length,
            end: bodyInput.selectionEnd ?? bodyInput.value.length
        };
        textInput.value = bodyInput.value.slice(savedSelection.start, savedSelection.end);
        urlInput.value = '';
        status.textContent = '';
        status.className = 'link-insert-status';
        panel.hidden = false;
        urlInput.focus();
    });
    cancelBtn.addEventListener('click', ()=>{
        panel.hidden = true;
    });
    confirmBtn.addEventListener('click', ()=>{
        const text = textInput.value.trim();
        const url = urlInput.value.trim();
        if (!text || !url) {
            status.textContent = 'Link text and URL are both required.';
            status.className = 'link-insert-status error';
            return;
        }
        if (!/^https?:\/\//i.test(url)) {
            status.textContent = 'URL must start with http:// or https://';
            status.className = 'link-insert-status error';
            return;
        }
        // Guard against brackets/parens in the label breaking the [text](url) syntax
        if (/[[\]()]/.test(text)) {
            status.textContent = "Link text can\u2019t contain [ ] ( ) characters.";
            status.className = 'link-insert-status error';
            return;
        }
        const markup = `[${text}](${url})`;
        const { start: start, end: end } = savedSelection;
        const value = bodyInput.value;
        bodyInput.value = value.slice(0, start) + markup + value.slice(end);
        bodyInput.focus();
        const caret = start + markup.length;
        bodyInput.setSelectionRange(caret, caret);
        panel.hidden = true;
    });
}
// ─── UI helpers ───────────────────────────────────────────────────────────────
function $c030929f534f7bed$var$setStatus(el, text, cls) {
    el.textContent = text;
    el.className = cls;
}
function $c030929f534f7bed$var$setUploadStatus(el, text, cls) {
    el.textContent = text;
    el.className = cls;
}
function $c030929f534f7bed$var$clearUploadStatus(el) {
    el.textContent = '';
    el.className = '';
}
// ─── Submit ───────────────────────────────────────────────────────────────────
async function $c030929f534f7bed$var$queueOfflinePost(postData, token, statusMsg) {
    await $c030929f534f7bed$var$ensureQueueReady();
    const record = await $c030929f534f7bed$var$postQueue.add(postData, token);
    $c030929f534f7bed$var$setStatus(statusMsg, "\uD83D\uDCF1 Saved offline \u2014 will publish when back online.", 'success');
    if ('serviceWorker' in navigator && 'SyncManager' in window) try {
        const reg = await navigator.serviceWorker.ready;
        await reg.sync.register('sync-posts');
    } catch  {
    // Background sync not available — the reconnect listener will retry
    }
    return record;
}
async function $c030929f534f7bed$var$handleSubmit({ title: title, body: body, media: media, form: form, submitBtn: submitBtn, uploadStatus: uploadStatus, statusMsg: statusMsg, onSuccess: onSuccess, onPublished: onPublished, onQueuedOffline: onQueuedOffline }) {
    submitBtn.disabled = true;
    $c030929f534f7bed$var$setStatus(statusMsg, "Publishing\u2026", '');
    try {
        let mediaUrl = '';
        // ── Media upload ────────────────────────────────────────────────────────
        if (media) {
            let fileToUpload = media.file;
            if (media.type === 'image') {
                $c030929f534f7bed$var$setUploadStatus(uploadStatus, "Compressing image\u2026", 'uploading');
                try {
                    fileToUpload = await $c030929f534f7bed$var$compressImage(media.file);
                } catch (err) {
                    console.warn('Compression failed, using original:', err);
                    fileToUpload = media.file;
                }
            }
            $c030929f534f7bed$var$setUploadStatus(uploadStatus, "Uploading media\u2026", 'uploading');
            try {
                const result = await (0, $egRyG.uploadToCloudinary)(fileToUpload);
                mediaUrl = result.secure_url;
                $c030929f534f7bed$var$clearUploadStatus(uploadStatus);
            } catch (err) {
                console.error('Cloudinary upload failed:', err);
                $c030929f534f7bed$var$setUploadStatus(uploadStatus, `Media upload failed: ${err.message}`, 'error');
                // Continue without media rather than blocking entirely
                mediaUrl = '';
            }
        }
        // ── Prepare post data ───────────────────────────────────────────────────
        const postData = {
            title: title.trim(),
            body: body.trim(),
            imageUrl: mediaUrl
        };
        // The token is read here rather than left to the API client because the
        // offline queue stores it alongside the post, to replay the publish from
        // the service worker once connectivity returns.
        const token = await (0, $5IRmI.getToken)() || '';
        // ── Check connectivity ──────────────────────────────────────────────────
        if (!navigator.onLine) {
            const record = await $c030929f534f7bed$var$queueOfflinePost(postData, token, statusMsg);
            form.reset();
            onSuccess();
            onQueuedOffline?.(record);
            return;
        }
        // ── Send to backend ─────────────────────────────────────────────────────
        const createdPost = await (0, $36CJS.api).posts.create(postData);
        $c030929f534f7bed$var$setStatus(statusMsg, "\u2713 Post published!", 'success');
        form.reset();
        onSuccess();
        onPublished?.(createdPost);
        setTimeout(()=>{
            statusMsg.textContent = '';
            statusMsg.className = '';
        }, 2500);
    } catch (err) {
        console.error('[post-composer] Post error:', err);
        $c030929f534f7bed$var$setStatus(statusMsg, `\u{2715} ${err.message}`, 'error');
    } finally{
        submitBtn.disabled = false;
    }
}
function $c030929f534f7bed$export$94a615a503370f61() {
    const title = document.getElementById('post-title');
    const body = document.getElementById('post-body');
    const media = document.getElementById('post-image');
    return !!(title?.value.trim() || body?.value.trim() || media?.files?.length);
}
function $c030929f534f7bed$export$4470b0aff7e42ff({ onPublished: onPublished, onQueuedOffline: onQueuedOffline } = {}) {
    const form = document.getElementById('post-form');
    const titleInput = document.getElementById('post-title');
    const bodyInput = document.getElementById('post-body');
    const mediaInput = document.getElementById('post-image');
    const previewWrap = document.getElementById('image-preview-wrap');
    const previewMedia = document.getElementById('preview-media');
    const removeBtn = document.getElementById('remove-image-btn');
    const uploadStatus = document.getElementById('upload-status');
    const statusMsg = document.getElementById('status-msg');
    const submitBtn = document.getElementById('submit-btn');
    // selectedMedia: { file: File, type: 'image'|'video'|'audio' } | null
    let selectedMedia = null;
    function clearPreview() {
        previewWrap.hidden = true;
        previewMedia.innerHTML = '';
    }
    function buildPreviewEl(file, type) {
        const objectUrl = URL.createObjectURL(file);
        if (type === 'image') {
            const img = document.createElement('img');
            img.src = objectUrl;
            img.alt = 'Image preview';
            return img;
        }
        if (type === 'video') {
            const video = document.createElement('video');
            video.src = objectUrl;
            video.controls = true;
            video.preload = 'metadata';
            video.setAttribute('playsinline', '');
            return video;
        }
        const audio = document.createElement('audio');
        audio.src = objectUrl;
        audio.controls = true;
        return audio;
    }
    // ── Media picker ──────────────────────────────────────────────────────────
    mediaInput.accept = 'image/*,video/*,audio/*';
    mediaInput.addEventListener('change', async (e)=>{
        const file = e.target.files?.[0];
        if (!file) return;
        $c030929f534f7bed$var$clearUploadStatus(uploadStatus);
        selectedMedia = null;
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        const isAudio = file.type.startsWith('audio/');
        if (!isImage && !isVideo && !isAudio) {
            $c030929f534f7bed$var$setUploadStatus(uploadStatus, 'Only images, videos, and audio files are supported.', 'error');
            mediaInput.value = '';
            return;
        }
        if (isVideo) try {
            const duration = await $c030929f534f7bed$var$getVideoDuration(file);
            if (duration > 120) {
                $c030929f534f7bed$var$setUploadStatus(uploadStatus, 'Videos must be under 2 minutes.', 'error');
                mediaInput.value = '';
                return;
            }
        } catch  {
            $c030929f534f7bed$var$setUploadStatus(uploadStatus, 'Could not read video metadata.', 'error');
            mediaInput.value = '';
            return;
        }
        const type = isImage ? 'image' : isVideo ? 'video' : 'audio';
        selectedMedia = {
            file: file,
            type: type
        };
        // Show local preview immediately (before upload)
        previewMedia.innerHTML = '';
        previewMedia.appendChild(buildPreviewEl(file, type));
        previewWrap.hidden = false;
    });
    removeBtn.addEventListener('click', ()=>{
        selectedMedia = null;
        mediaInput.value = '';
        clearPreview();
        $c030929f534f7bed$var$clearUploadStatus(uploadStatus);
    });
    // ── Insert-link toolbar ─────────────────────────────────────────────────
    $c030929f534f7bed$var$initLinkInsertPanel(bodyInput);
    $c030929f534f7bed$var$initReadMoreButton(bodyInput);
    function resetForm() {
        form.reset();
        selectedMedia = null;
        mediaInput.value = '';
        clearPreview();
        $c030929f534f7bed$var$clearUploadStatus(uploadStatus);
        $c030929f534f7bed$var$setStatus(statusMsg, '', '');
    }
    // ── Submit ────────────────────────────────────────────────────────────────
    form.addEventListener('submit', async (e)=>{
        e.preventDefault();
        await $c030929f534f7bed$var$handleSubmit({
            title: titleInput.value,
            body: bodyInput.value,
            media: selectedMedia,
            form: form,
            submitBtn: submitBtn,
            uploadStatus: uploadStatus,
            statusMsg: statusMsg,
            onSuccess: ()=>{
                selectedMedia = null;
                mediaInput.value = '';
                clearPreview();
                $c030929f534f7bed$var$clearUploadStatus(uploadStatus);
            },
            onPublished: onPublished,
            onQueuedOffline: onQueuedOffline
        });
    });
    return {
        reset: resetForm
    };
}
async function $c030929f534f7bed$export$d3c5d8964ec31a13(reg) {
    await $c030929f534f7bed$var$ensureQueueReady();
    const pending = await $c030929f534f7bed$var$postQueue.getAll().catch(()=>[]);
    if (pending.length && navigator.onLine && 'SyncManager' in window) try {
        await reg.sync.register('sync-posts');
    } catch  {
    // Background sync not available — the reconnect listener will retry
    }
}
function $c030929f534f7bed$export$48211b535e2492e0() {
    window.addEventListener('online', async ()=>{
        await $c030929f534f7bed$var$ensureQueueReady();
        const pending = await $c030929f534f7bed$var$postQueue.getAll().catch(()=>[]);
        if (!pending.length) return;
        for (const record of pending)try {
            // Not the api client: this replays a queued post using the token
            // captured when it was written, not the current session's.
            const res = await fetch('/api/v1/posts', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...record.token ? {
                        Authorization: `Bearer ${record.token}`
                    } : {}
                },
                body: JSON.stringify(record.data)
            });
            if (res.ok) await $c030929f534f7bed$var$postQueue.remove(record.id);
            else if (res.status >= 400 && res.status < 500) // Unrecoverable — drop it
            await $c030929f534f7bed$var$postQueue.remove(record.id);
        } catch  {
        // Still offline or transient error — leave in queue
        }
    });
}

});


//# sourceMappingURL=app.48b2a3b9.js.map
